/** Roles that may upload / delete documents. Other users may only view via derived access. */
export const DOCUMENT_HUB_MANAGER_ROLES = [
  "super admin",
  "admin",
  "inside sales",
  "accounts",
  "accounts admin",
  "travel coordinator",
  "payroll coordinator",
];

/** Linked record types used in document_relationship (design.md §7). */
export const DOCUMENT_ENTITY_TYPES = [
  { value: "PROJECT", label: "Project" },
  { value: "CUSTOMER", label: "Customer" },
  { value: "PARTNER", label: "Partner" },
  { value: "PURCHASE_ORDER", label: "Purchase order" },
  { value: "QUOTE", label: "Quote" },
  { value: "INVOICE", label: "Invoice" },
  { value: "CUSTOM_EXPENSE_INVOICE", label: "Custom expense invoice" },
  { value: "EXPENSE", label: "Expense" },
  { value: "EMPLOYEE", label: "Employee" },
  { value: "TRAVEL_REQUEST", label: "Travel request" },
  { value: "EA_RENEWAL", label: "EA renewal" },
  { value: "VENDOR", label: "Vendor" },
  { value: "FISCAL_YEAR", label: "Fiscal year" },
  { value: "BUSINESS_UNIT", label: "Business unit" },
  { value: "DEPARTMENT", label: "Department" },
];

export function formatEntityType(value) {
  if (!value) return "—";
  const match = DOCUMENT_ENTITY_TYPES.find((t) => t.value === value);
  if (match) return match.label;
  return value.replace(/_/g, " ").toLowerCase().replace(/^\w/, (c) => c.toUpperCase());
}

export function formatRelationshipDisplay(relationship) {
  if (!relationship) return "—";
  const type = formatEntityType(relationship.entityType);
  const value =
    relationship.entityLabel ||
    relationship.entityRef ||
    (relationship.entityId != null ? String(relationship.entityId) : "—");
  return `${type}: ${value}`;
}
